import { teamPitchEventsAtom, teamUnwrappedPitchEventsAtom } from '@/atoms/vis/teamVis';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { EventBuckets } from '@/components/visualisations/EventBuckets';
import { PitchVisComponentProps } from '@/types/visualisation';

export const TeamEventBuckets = ({ allowInteraction }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <EventBuckets
      allowInteraction={allowInteraction}
      pitchEventsAtom={teamPitchEventsAtom}
      unwrappedPitchEventsAtom={teamUnwrappedPitchEventsAtom}
    />
  </MetricKeyFallbackWrapper>
);
